function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { escapeHtml } from '../utils/escape-html';
import { clone } from '../renderer/utils/clone';
import { getValueByIdentifierFromContext } from '../tags';
import { SELF_REF_PATTERN_PREFIX, PATTERN_PREFIX, PATTERN_SUFFIX } from '../consts';
import { resolveStructuredData } from './structured-data';
export function fillInPatternBlob(patternBlob, context) {
  var blob = clone(patternBlob);
  blob.tags = blob.tags.map(function (tag) {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, tag), tag.props !== undefined ? {
      props: fillIn(tag.props, context, blob.tags)
    } : {}), tag.children !== undefined ? {
      children: fillPatternValue(tag.children, context, blob.tags)
    } : {}), tag.disabled !== undefined ? {
      disabled: fillPatternValue(tag.disabled, context, blob.tags)
    } : {});
  }).filter(function (tag) {
    return !tag.props || !tag.props.isEmptyTag;
  });
  return blob;
}
export function fillPatternValue(value, context, tags, referencePath) {
  if (referencePath === void 0) {
    referencePath = [];
  }

  if (typeof value !== 'string') {
    return value;
  }

  var patternRegex = new RegExp(PATTERN_PREFIX + ".+?" + PATTERN_SUFFIX, 'g');
  var patternValue = value.replace(patternRegex, replacePatternWithValue);
  return isStructuredData(value) ? resolveStructuredData(patternValue) : patternValue;

  function replacePatternWithValue(placeholder) {
    var isSelfRef = placeholder.startsWith("" + SELF_REF_PATTERN_PREFIX);
    var isFirstTimeRef = !referencePath.some(function (item) {
      return item === placeholder;
    });
    var contextPath = getContextPath(placeholder);
    return isSelfRef && isFirstTimeRef ? getSelfRefPatternValue() : getContextValue();

    function getSelfRefPatternValue() {
      referencePath.push(placeholder);
      return getValueByIdentifierFromContext([{
        tags: tags
      }], contextPath, context, referencePath) || '';
    }

    function getContextValue() {
      var contextValue = context && context[contextPath] || '';

      if (typeof contextValue === 'string') {
        return escapeForJson(value, contextValue);
      } else {
        return JSON.stringify(contextValue);
      }
    }
  }
}

function isStructuredData(value) {
  return value.includes("\"@context\": \"https://schema.org");
}

function escapeForJson(value, contextValue) {
  if (!isStructuredData(value)) {
    return contextValue;
  }

  return escapeHtml(contextValue, {
    strictForJson: true
  });
}

function fillIn(keyValue, context, tags) {
  return Object.keys(keyValue).reduce(function (acc, curr) {
    var value = keyValue[curr];

    if (typeof value === 'string') {
      acc[curr] = fillPatternValue(value, context, tags);
    } else {
      acc[curr] = value;
    }

    if (acc[curr] === '') {
      acc.isEmptyTag = true;
    }

    return acc;
  }, {});
}

function getContextPath(initialPlaceholder) {
  var decorators = [SELF_REF_PATTERN_PREFIX, PATTERN_PREFIX, PATTERN_SUFFIX];
  return decorators.reduce(function (result, decorator) {
    return result.replace(decorator, '');
  }, initialPlaceholder);
}